import cls from 'classnames';
import logo from '@/assets/images/sciex/sciex_logo.png';
import dianhua from '@/assets/images/sciex/dianhua.png';
import styles from './indedx.module.scss';
export default () => {
  return (
    <div className={cls(styles['header-container'], 'flex', 'v-center')}>
      <div className={styles['left-icon']}>
        <img src={logo} />
      </div>
      <div className={cls(styles['telephone'], 'flex', 'v-center')}>
        <img src={dianhua} className={styles['telephone-icon']} />
        <span className={styles['telephone-text']}>400-821-8397</span>
      </div>
    </div>
  );
};
